module.exports = __webpack_public_path__ + "static/img/pic_2_3@2x.c43ce0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/shortVideo/pic_2_3@2x.png
// module id = x4sA
// module chunks = 0